import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { DocumentSection } from '../documents/DocumentSection';
import IconInstallments from '@/assets/icons/heroIcons/Installments.svg';
import IconScale from '@/assets/icons/heroIcons/Scale.svg';
export function PaymentOfDebt() {
  const $ = _c(194);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("paymentOfDebt.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="paymentOfDebt.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("paymentOfDebt.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mb-10 text-center text-gray-800 md:mb-16">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto max-w-192">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("paymentOfDebt.installmentPlan.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("paymentOfDebt.installmentPlan.subtitle");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <span className="mt-1 block text-base">{t8}</span>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <>{t6}{t7}{t9}</>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconInstallments className="h-10 w-10 text-blue-500" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("paymentOfDebt.installmentPlan.text");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <Text variant="p2" as="p" className="mb-6" weight="semibold">{t12}</Text>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("paymentOfDebt.installmentPlan.table.1.title");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <td className="text-left">{t14}</td>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("paymentOfDebt.installmentPlan.table.1.value");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <td className="text-right font-bold">{t16}</td>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <tr className="flex justify-between">{t15}{t17}</tr>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("paymentOfDebt.installmentPlan.table.2.title");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t19) {
    t20 = <td className="text-left">{t19}</td>;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("paymentOfDebt.installmentPlan.table.2.value");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21) {
    t22 = <td className="text-right font-bold">{t21}</td>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t20 || $[47] !== t22) {
    t23 = <tr className="flex justify-between">{t20}{t22}</tr>;
    $[46] = t20;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t("paymentOfDebt.installmentPlan.table.3.title");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t24) {
    t25 = <td className="text-left">{t24}</td>;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t) {
    t26 = t("paymentOfDebt.installmentPlan.table.3.value");
    $[53] = t;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t26) {
    t27 = <td className="text-right font-bold">{t26}</td>;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t25 || $[58] !== t27) {
    t28 = <tr className="flex justify-between">{t25}{t27}</tr>;
    $[57] = t25;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t18 || $[61] !== t23 || $[62] !== t28) {
    t29 = <table className="w-full"><tbody className="space-y-4">{t18}{t23}{t28}</tbody></table>;
    $[60] = t18;
    $[61] = t23;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t10 || $[65] !== t13 || $[66] !== t29) {
    t30 = <DocumentSection smallArrow={true} title={t10} icon={t11} defaultOpen={false}>{t13}{t29}</DocumentSection>;
    $[64] = t10;
    $[65] = t13;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t) {
    t31 = t("paymentOfDebt.courtEnforcement.title");
    $[68] = t;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <br />;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== t) {
    t33 = t("paymentOfDebt.courtEnforcement.subtitle");
    $[71] = t;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== t33) {
    t34 = <span className="mt-1 block text-base">{t33}</span>;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t31 || $[76] !== t34) {
    t35 = <>{t31}{t32}{t34}</>;
    $[75] = t31;
    $[76] = t34;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <IconScale className="h-10 w-10 text-blue-500" />;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t) {
    t37 = t("paymentOfDebt.courtEnforcement.text");
    $[79] = t;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t37) {
    t38 = <Text variant="p2" as="p" className="mb-6" weight="semibold">{t37}</Text>;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t) {
    t39 = t("paymentOfDebt.courtEnforcement.table.1.title");
    $[83] = t;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  let t40;
  if ($[85] !== t39) {
    t40 = <td className="text-left">{t39}</td>;
    $[85] = t39;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] !== t) {
    t41 = t("paymentOfDebt.courtEnforcement.table.1.value");
    $[87] = t;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] !== t41) {
    t42 = <td className="text-right font-bold">{t41}</td>;
    $[89] = t41;
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  let t43;
  if ($[91] !== t40 || $[92] !== t42) {
    t43 = <tr className="flex justify-between">{t40}{t42}</tr>;
    $[91] = t40;
    $[92] = t42;
    $[93] = t43;
  } else {
    t43 = $[93];
  }
  let t44;
  if ($[94] !== t) {
    t44 = t("paymentOfDebt.courtEnforcement.table.2.title");
    $[94] = t;
    $[95] = t44;
  } else {
    t44 = $[95];
  }
  let t45;
  if ($[96] !== t44) {
    t45 = <td className="text-left">{t44}</td>;
    $[96] = t44;
    $[97] = t45;
  } else {
    t45 = $[97];
  }
  let t46;
  if ($[98] !== t) {
    t46 = t("paymentOfDebt.courtEnforcement.table.2.value");
    $[98] = t;
    $[99] = t46;
  } else {
    t46 = $[99];
  }
  let t47;
  if ($[100] !== t46) {
    t47 = <td className="text-right font-bold">{t46}</td>;
    $[100] = t46;
    $[101] = t47;
  } else {
    t47 = $[101];
  }
  let t48;
  if ($[102] !== t45 || $[103] !== t47) {
    t48 = <tr className="flex justify-between">{t45}{t47}</tr>;
    $[102] = t45;
    $[103] = t47;
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  let t49;
  if ($[105] !== t) {
    t49 = t("paymentOfDebt.courtEnforcement.table.3.title");
    $[105] = t;
    $[106] = t49;
  } else {
    t49 = $[106];
  }
  let t50;
  if ($[107] !== t49) {
    t50 = <td className="text-left">{t49}</td>;
    $[107] = t49;
    $[108] = t50;
  } else {
    t50 = $[108];
  }
  let t51;
  if ($[109] !== t) {
    t51 = t("paymentOfDebt.courtEnforcement.table.3.value");
    $[109] = t;
    $[110] = t51;
  } else {
    t51 = $[110];
  }
  let t52;
  if ($[111] !== t51) {
    t52 = <td className="text-right font-bold">{t51}</td>;
    $[111] = t51;
    $[112] = t52;
  } else {
    t52 = $[112];
  }
  let t53;
  if ($[113] !== t50 || $[114] !== t52) {
    t53 = <tr className="flex justify-between">{t50}{t52}</tr>;
    $[113] = t50;
    $[114] = t52;
    $[115] = t53;
  } else {
    t53 = $[115];
  }
  let t54;
  if ($[116] !== t) {
    t54 = t("paymentOfDebt.courtEnforcement.table.4.title");
    $[116] = t;
    $[117] = t54;
  } else {
    t54 = $[117];
  }
  let t55;
  if ($[118] !== t54) {
    t55 = <td className="text-left">{t54}</td>;
    $[118] = t54;
    $[119] = t55;
  } else {
    t55 = $[119];
  }
  let t56;
  if ($[120] !== t) {
    t56 = t("paymentOfDebt.courtEnforcement.table.4.value");
    $[120] = t;
    $[121] = t56;
  } else {
    t56 = $[121];
  }
  let t57;
  if ($[122] !== t56) {
    t57 = <td className="text-right font-bold">{t56}</td>;
    $[122] = t56;
    $[123] = t57;
  } else {
    t57 = $[123];
  }
  let t58;
  if ($[124] !== t55 || $[125] !== t57) {
    t58 = <tr className="flex justify-between">{t55}{t57}</tr>;
    $[124] = t55;
    $[125] = t57;
    $[126] = t58;
  } else {
    t58 = $[126];
  }
  let t59;
  if ($[127] !== t) {
    t59 = t("paymentOfDebt.courtEnforcement.table.5.title");
    $[127] = t;
    $[128] = t59;
  } else {
    t59 = $[128];
  }
  let t60;
  if ($[129] !== t59) {
    t60 = <td className="text-left">{t59}</td>;
    $[129] = t59;
    $[130] = t60;
  } else {
    t60 = $[130];
  }
  let t61;
  if ($[131] !== t) {
    t61 = t("paymentOfDebt.courtEnforcement.table.5.value");
    $[131] = t;
    $[132] = t61;
  } else {
    t61 = $[132];
  }
  let t62;
  if ($[133] !== t61) {
    t62 = <td className="text-right font-bold">{t61}</td>;
    $[133] = t61;
    $[134] = t62;
  } else {
    t62 = $[134];
  }
  let t63;
  if ($[135] !== t60 || $[136] !== t62) {
    t63 = <tr className="flex justify-between">{t60}{t62}</tr>;
    $[135] = t60;
    $[136] = t62;
    $[137] = t63;
  } else {
    t63 = $[137];
  }
  let t64;
  if ($[138] !== t) {
    t64 = t("paymentOfDebt.courtEnforcement.table.6.title");
    $[138] = t;
    $[139] = t64;
  } else {
    t64 = $[139];
  }
  let t65;
  if ($[140] !== t64) {
    t65 = <td className="text-left">{t64}</td>;
    $[140] = t64;
    $[141] = t65;
  } else {
    t65 = $[141];
  }
  let t66;
  if ($[142] !== t) {
    t66 = t("paymentOfDebt.courtEnforcement.table.6.value");
    $[142] = t;
    $[143] = t66;
  } else {
    t66 = $[143];
  }
  let t67;
  if ($[144] !== t66) {
    t67 = <td className="text-right font-bold">{t66}</td>;
    $[144] = t66;
    $[145] = t67;
  } else {
    t67 = $[145];
  }
  let t68;
  if ($[146] !== t65 || $[147] !== t67) {
    t68 = <tr className="flex justify-between">{t65}{t67}</tr>;
    $[146] = t65;
    $[147] = t67;
    $[148] = t68;
  } else {
    t68 = $[148];
  }
  let t69;
  if ($[149] !== t) {
    t69 = t("paymentOfDebt.courtEnforcement.table.7.title");
    $[149] = t;
    $[150] = t69;
  } else {
    t69 = $[150];
  }
  let t70;
  if ($[151] !== t69) {
    t70 = <td className="text-left"><i>{t69}</i></td>;
    $[151] = t69;
    $[152] = t70;
  } else {
    t70 = $[152];
  }
  let t71;
  if ($[153] !== t) {
    t71 = t("paymentOfDebt.courtEnforcement.table.7.value");
    $[153] = t;
    $[154] = t71;
  } else {
    t71 = $[154];
  }
  let t72;
  if ($[155] !== t71) {
    t72 = <td className="text-right font-bold">{t71}</td>;
    $[155] = t71;
    $[156] = t72;
  } else {
    t72 = $[156];
  }
  let t73;
  if ($[157] !== t70 || $[158] !== t72) {
    t73 = <tr className="flex justify-between">{t70}{t72}</tr>;
    $[157] = t70;
    $[158] = t72;
    $[159] = t73;
  } else {
    t73 = $[159];
  }
  let t74;
  if ($[160] !== t) {
    t74 = t("paymentOfDebt.courtEnforcement.table.8.title");
    $[160] = t;
    $[161] = t74;
  } else {
    t74 = $[161];
  }
  let t75;
  if ($[162] !== t74) {
    t75 = <td className="text-left">{t74}</td>;
    $[162] = t74;
    $[163] = t75;
  } else {
    t75 = $[163];
  }
  let t76;
  if ($[164] !== t) {
    t76 = t("paymentOfDebt.courtEnforcement.table.8.value");
    $[164] = t;
    $[165] = t76;
  } else {
    t76 = $[165];
  }
  let t77;
  if ($[166] !== t76) {
    t77 = <td className="text-right font-bold">{t76}</td>;
    $[166] = t76;
    $[167] = t77;
  } else {
    t77 = $[167];
  }
  let t78;
  if ($[168] !== t75 || $[169] !== t77) {
    t78 = <tr className="flex justify-between">{t75}{t77}</tr>;
    $[168] = t75;
    $[169] = t77;
    $[170] = t78;
  } else {
    t78 = $[170];
  }
  let t79;
  if ($[171] !== t43 || $[172] !== t48 || $[173] !== t53 || $[174] !== t58 || $[175] !== t63 || $[176] !== t68 || $[177] !== t73 || $[178] !== t78) {
    t79 = <table className="w-full"><tbody className="space-y-4">{t43}{t48}{t53}{t58}{t63}{t68}{t73}{t78}</tbody></table>;
    $[171] = t43;
    $[172] = t48;
    $[173] = t53;
    $[174] = t58;
    $[175] = t63;
    $[176] = t68;
    $[177] = t73;
    $[178] = t78;
    $[179] = t79;
  } else {
    t79 = $[179];
  }
  let t80;
  if ($[180] !== t35 || $[181] !== t38 || $[182] !== t79) {
    t80 = <DocumentSection smallArrow={true} title={t35} icon={t36} defaultOpen={false}>{t38}{t79}</DocumentSection>;
    $[180] = t35;
    $[181] = t38;
    $[182] = t79;
    $[183] = t80;
  } else {
    t80 = $[183];
  }
  let t81;
  if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = <br />;
    $[184] = t81;
  } else {
    t81 = $[184];
  }
  let t82;
  if ($[185] !== t) {
    t82 = <Text variant="p4" className="mx-auto mt-2 max-w-192 text-center"><Trans t={t} i18nKey="paymentOfDebt.textUnderTable">{t81}</Trans></Text>;
    $[185] = t;
    $[186] = t82;
  } else {
    t82 = $[186];
  }
  let t83;
  if ($[187] !== t30 || $[188] !== t80 || $[189] !== t82) {
    t83 = <div className="mx-auto max-w-242"><div className="flex flex-col gap-4">{t30}{t80}{t82}</div></div>;
    $[187] = t30;
    $[188] = t80;
    $[189] = t82;
    $[190] = t83;
  } else {
    t83 = $[190];
  }
  let t84;
  if ($[191] !== t5 || $[192] !== t83) {
    t84 = <div className="relative z-10 px-4">{t5}{t83}</div>;
    $[191] = t5;
    $[192] = t83;
    $[193] = t84;
  } else {
    t84 = $[193];
  }
  return t84;
}